import style from '@trustoo/components/ui/loadingDots.module.css'
import clsx from 'clsx'
import { CSSProperties, ReactElement } from 'react'

interface LoadingDotsProps {
    className?: string
    size?: string | number
    color?: string
    duration?: string
    style?: CSSProperties
    dotElement?: ReactElement
}

const LoadingDots = ({
    className,
    size,
    color,
    duration,
    style: inlineStyle,
    dotElement,
}: LoadingDotsProps) => {
    const dotEl = dotElement || (
        <span
            style={{
                backgroundColor: color,
                animationDuration: duration,
            }}
        />
    )
    return (
        <span
            className={clsx(style.root, className)}
            style={{ fontSize: size, ...(inlineStyle || {}) }}>
            {dotEl}
            {dotEl}
            {dotEl}
        </span>
    )
}

export default LoadingDots
